import React from 'react';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { MOTOR_TYPES, DIKEY_DIRECTION_TYPES } from '../../../../constants';
import { formatPrice, applyEgimFarkiUnitPrice } from '../../../../utils';
import { handleNumericKeyDown, customSelectStyles } from '../OrderFormUtils';

const DikeyForm = ({
  newOrder,
  onFieldChange,
  isLoading,
  productItems,
  productOptions,
  handleProductSelect,
  adminSettings,
  selectedProductType,
  handleMotorTypeChange
}) => {
  const resolveBaseUnitPrice = () => {
    if (newOrder.baseUnitPrice !== undefined && newOrder.baseUnitPrice !== null && newOrder.baseUnitPrice !== '') {
      return Number(newOrder.baseUnitPrice) || 0;
    }
    return Number(newOrder.unitPrice) || 0;
  };

  const getFonExtra = (hasFon = newOrder.hasDikeyFon) => (
    (selectedProductType === 'dikeyPerde' && hasFon)
      ? Number(adminSettings.dikeyFonPrice) || 0
      : 0
  );

  const applyUnitPrice = (base, hasFon = newOrder.hasDikeyFon, hasEgimFarki = newOrder.hasEgimFarki) => {
    const next = applyEgimFarkiUnitPrice(base, getFonExtra(hasFon), hasEgimFarki);
    onFieldChange('baseUnitPrice', base);
    onFieldChange('unitPrice', next);
  };

  const fonDisabled = !newOrder.unitPrice || !!newOrder.hasEgimFarki || isLoading;

  return (
    <>
      <div className="form-group">
        <label>Oda Adı *</label>
        <input type="text" value={newOrder.roomName || ''} onChange={(e) => onFieldChange('roomName', e.target.value)} required disabled={isLoading} />
      </div>
      <div className="form-group">
        <label>Ürün Adı *</label>
        <CreatableSelect
          options={productOptions}
          value={
            productOptions.find(o => o.value === (productItems.find(p => p.name === newOrder.productName)?.id)) ||
            (newOrder.productName ? { value: newOrder.productName, label: newOrder.productName } : null)
          }
          onChange={(option) => {
            if (!option) {
              onFieldChange('productName', '');
              onFieldChange('unitPrice', '');
              onFieldChange('baseUnitPrice', '');
            } else if (option.__isNew__) {
              onFieldChange('productName', option.value);
              onFieldChange('unitPrice', '');
              onFieldChange('baseUnitPrice', '');
            } else {
              handleProductSelect(option.value);
            }
          }}
          isDisabled={isLoading} isClearable isSearchable placeholder="Ürün seçin veya yazın..." noOptionsMessage={() => "Ürün bulunamadı"} formatCreateLabel={(inputValue) => `"${inputValue}" olarak ekle`} styles={customSelectStyles}
        />
      </div>
      <div className="form-group">
        <label>Ürün Varyantı</label>
        <input type="text" value={newOrder.productVariant || ''} onChange={(e) => onFieldChange('productVariant', e.target.value)} disabled={isLoading} placeholder="Varyant giriniz..." />
      </div>

      <div className="form-group">
        <label>En (cm) *</label>
        <input type="number" step="0.01" value={newOrder.width || ''} onKeyDown={handleNumericKeyDown} onChange={(e) => onFieldChange('width', e.target.value)} required disabled={isLoading} />
      </div>
      <div className="form-group">
        <label>Boy (cm) *</label>
        <input type="number" step="0.01" value={newOrder.height || ''} onKeyDown={handleNumericKeyDown} onChange={(e) => onFieldChange('height', e.target.value)} required disabled={isLoading} />
      </div>
      <div className="form-group">
        <label>Yön *</label>
        <select value={newOrder.direction || ''} onChange={(e) => onFieldChange('direction', e.target.value)} required disabled={isLoading}>
          <option value="">Seçiniz</option>
          {Object.entries(DIKEY_DIRECTION_TYPES).map(([key, value]) => (<option key={key} value={value}>{value}</option>))}
        </select>
      </div>

      {newOrder.width && newOrder.usedM2 && (
        <div className="form-group">
          <label>Kullanılan Mt²</label>
          <input type="text" value={newOrder.usedM2} readOnly className="readonly-field" />
        </div>
      )}

      <div className="form-group">
        <label>Birim Fiyat (₺) *</label>
        <input
          type="number"
          step="0.01"
          min="0"
          value={newOrder.unitPrice || ''}
          onKeyDown={handleNumericKeyDown}
          onFocus={() => {
            if (newOrder.baseUnitPrice !== undefined && newOrder.baseUnitPrice !== null && newOrder.baseUnitPrice !== '') {
              onFieldChange('unitPrice', newOrder.baseUnitPrice);
            }
          }}
          onChange={(e) => {
            onFieldChange('baseUnitPrice', e.target.value);
            onFieldChange('unitPrice', e.target.value);
          }}
          onBlur={(e) => {
            applyUnitPrice(Number(e.target.value) || 0);
          }}
          required
          disabled={isLoading}
        />
      </div>

      {selectedProductType === 'dikeyPerde' && (
        <>
          <div className="form-group">
            <label>&nbsp;</label>
            <label
              style={{
                display: 'flex',
                alignItems: 'center',
                height: '42px',
                padding: '0 12px',
                border: '1px solid #cbd5e1',
                borderRadius: '6px',
                width: '100%',
                backgroundColor: fonDisabled ? '#f1f5f9' : '#f8fafc',
                cursor: fonDisabled ? 'not-allowed' : 'pointer',
                margin: 0,
                transition: 'all 0.2s ease',
                opacity: fonDisabled ? 0.6 : 1
              }}
              title={newOrder.hasEgimFarki ? 'Fon seçmek için önce Eğim Farkı işaretini kaldırın' : undefined}
            >
              <input
                type="checkbox"
                disabled={fonDisabled}
                style={{ width: '16px', height: '16px', marginRight: '10px', cursor: fonDisabled ? 'not-allowed' : 'pointer', accentColor: '#29472d' }}
                checked={newOrder.hasDikeyFon || false}
                onChange={(e) => {
                  const checked = e.target.checked;
                  onFieldChange('hasDikeyFon', checked);
                  const fonPrice = Number(adminSettings.dikeyFonPrice) || 0;
                  onFieldChange('dikeyFonAmount', checked ? fonPrice : 0);
                  if (checked && !newOrder.dikeyFonCount) onFieldChange('dikeyFonCount', 1);
                  applyUnitPrice(resolveBaseUnitPrice(), checked, newOrder.hasEgimFarki);
                }}
              />
              <span style={{ fontWeight: '500', fontSize: '13px', color: '#334155' }}>Fon (+{adminSettings.dikeyFonPrice} ₺)</span>
            </label>
          </div>
          {newOrder.hasDikeyFon && (
            <>
              <div className="form-group">
                <label>Fon Adı *</label>
                {adminSettings.dikeyFonList && adminSettings.dikeyFonList.length > 0 ? (
                  <Select options={adminSettings.dikeyFonList.map(f => ({ value: f, label: f }))} value={newOrder.dikeyFonName ? { value: newOrder.dikeyFonName, label: newOrder.dikeyFonName } : null} onChange={(option) => onFieldChange('dikeyFonName', option ? option.value : '')} isDisabled={isLoading} isClearable isSearchable placeholder="Fon seçiniz..." styles={customSelectStyles} />
                ) : (
                  <input type="text" value={newOrder.dikeyFonName || ''} onChange={(e) => onFieldChange('dikeyFonName', e.target.value)} disabled={isLoading} placeholder="Fon adı girin" />
                )}
              </div>
              <div className="form-group">
                <label>Fon Sayısı</label>
                <input type="number" step="1" min="1" value={newOrder.dikeyFonCount || ''} onChange={(e) => { let val = e.target.value; if (val !== '' && parseInt(val) < 1) val = '1'; onFieldChange('dikeyFonCount', val); }} disabled={isLoading} />
              </div>
            </>
          )}
        </>
      )}

      <div className="form-group">
        <label>Motor</label>
        <select value={newOrder.motorType || ''} onChange={handleMotorTypeChange} disabled={isLoading}>
          <option value="">Seçiniz</option>
          {Object.entries(MOTOR_TYPES).map(([key, value]) => (<option key={key} value={value}>{value}</option>))}
        </select>
      </div>
      {newOrder.motorType && (
        <div className="form-group">
          <label>Motor Ücreti ({adminSettings[`${selectedProductType}MotorCurrency`] || 'USD'})</label>
          <input type="number" step="0.01" value={newOrder.motorPriceCurrency || ''} onKeyDown={handleNumericKeyDown} onChange={(e) => onFieldChange('motorPriceCurrency', e.target.value)} disabled={isLoading} />
          {newOrder.motorPriceCurrency && <small style={{ display: 'block', marginTop: '5px', color: '#29472d' }}>≈ {newOrder.motorPrice ? Number(newOrder.motorPrice).toFixed(2) : 0} ₺</small>}
        </div>
      )}
      <div className="form-group">
        <label>Montaj (₺)</label>
        <input type="number" step="0.01" value={newOrder.mounting || ''} onChange={(e) => onFieldChange('mounting', e.target.value)} disabled={isLoading} />
      </div>

      <div className="form-group">
        <label>&nbsp;</label>
        <label
          style={{
            display: 'flex',
            alignItems: 'center',
            height: '42px',
            padding: '0 12px',
            border: '1px solid #cbd5e1',
            borderRadius: '6px',
            width: '100%',
            backgroundColor: !newOrder.unitPrice ? '#f1f5f9' : '#f8fafc',
            cursor: !newOrder.unitPrice || isLoading ? 'not-allowed' : 'pointer',
            margin: 0,
            transition: 'all 0.2s ease',
            opacity: !newOrder.unitPrice ? 0.6 : 1
          }}
          title={!newOrder.unitPrice ? 'Eğim Farkı için önce birim fiyat girin' : undefined}
        >
          <input
            type="checkbox"
            style={{
              width: '16px',
              height: '16px',
              marginRight: '10px',
              cursor: !newOrder.unitPrice || isLoading ? 'not-allowed' : 'pointer',
              accentColor: '#29472d'
            }}
            checked={newOrder.hasEgimFarki || false}
            disabled={!newOrder.unitPrice || isLoading}
            onChange={(e) => {
              const checked = e.target.checked;
              onFieldChange('hasEgimFarki', checked);
              applyUnitPrice(resolveBaseUnitPrice(), newOrder.hasDikeyFon, checked);
            }}
          />
          <span style={{ fontWeight: '500', fontSize: '13px', color: '#334155' }}>Eğim Farkı (+%50)</span>
        </label>
      </div>

      <div className="form-group">
        <label>Adet *</label>
        <input
          type="number"
          min="1"
          value={newOrder.quantity || ''}
          onKeyDown={handleNumericKeyDown}
          onChange={(e) => onFieldChange('quantity', e.target.value)}
          required
          disabled={isLoading}
          placeholder="Adet giriniz"
        />
      </div>

      {newOrder.productName && (
        <div className="form-group">
          <label>Toplam Tutar (₺)</label>
          <input
            type="text"
            value={formatPrice(newOrder.totalPrice)}
            readOnly
            className="readonly-field total-price"
          />
        </div>
      )}

    </>
  );
};

export default DikeyForm;
